import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full gap-2
    px-5 py-3.5
    font-bold text-sm sm:text-base uppercase tracking-wide whitespace-nowrap
    rounded-xl
    bg-brand-blue text-white
    hover:bg-brand-sky hover:scale-[1.02] hover:shadow-xl
    transition-all duration-200
    border-b-4 border-brand-ink/30 active:border-b-0 active:translate-y-1
    shadow-lg shadow-brand-blue/25
    ${className}
  `;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-35">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-36">
      {children}
    </button>;
}